var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fields.length)?_c('div',_vm._l((_vm.fields),function(field,fieldIndex){return _c('div',{key:fieldIndex},[_c('Textarea',{attrs:{"label":_vm.label + '-' + (fieldIndex + 1),"startValue":field},model:{value:(_vm.fields[fieldIndex]),callback:function ($$v) {_vm.$set(_vm.fields, fieldIndex, $$v)},expression:"fields[fieldIndex]"}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }